module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "parent",
    staticClass: "z-big-date",
    class: {
      'focus': _vm.focus,
      'no-label': (_vm.$props.label ? false : true),
      'has-value': _vm.$props.value,
      'has-error': _vm.error && _vm.error.length,
      'disabled': _vm.$props.disabled,
      'readonly': _vm.$props.readonly
    }
  }, [_c('div', {
    staticClass: "z-big-date-container",
    class: {
      'active': _vm.focus
    },
    on: {
      "click": _vm.onInputClick
    }
  }, [_c('div', {
    staticClass: "icon",
    domProps: {
      "innerHTML": _vm._s(_vm.$props.icon)
    }
  }), _c('div', {
    staticClass: "z-big-date-input"
  }, [_vm._t("default")], 2), _c('datetime', {
    ref: "input",
    attrs: {
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "placeholder": _vm.$props.label,
      "type": "date",
      "use12-hour": false,
      "week-start": 1,
      "phrases": {
        ok: 'Ок',
        cancel: 'Отмена'
      }
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  })], 1), (_vm.error) ? _c('span', {
    staticClass: "z-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b0df536","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZBigDate.vue
// module id = 1129
// module chunks = 0